<ng-container>
  <div class="subtitle-container">
    <b class="subtitle">
      REGISTRO NACIONAL DE CURSOS DE CAPACITACIÓN BASADOS EN ESTÁNDARES DE
      COMPETENCIA
    </b>
  </div>

  <div class="lead">
    <p>
      El Registro Nacional de Cursos de Capacitación Basados en Estándares de
      Competencia es el catálogo que facilita la consulta y acceso a los
      trabajadores, empresarios, sector social, sector educativo y sector
      gobierno, a los programas de los cursos de capacitación que han sido
      inscritos y gestionados por Centros de Capacitación o Capacitadores
      Independientes, con base en Estándares de Competencia inscritos en el
      Registro Nacional de Estándares de Competencia.
    </p>

    <p>
      Con el propósito de mejorar la articulación de los Sistemas de
      Normalización, formación, capacitación, evaluación y certificación de
      competencias, el CONOCER ha desarrollado los materiales necesarios para la
      implementación de cursos alineados a Estándares de Competencia los cuales
      incluyen Descripción del Curso, Manual del Instructor y Manual del
      Participante, mismos que están a disposición de los Prestadores de
      Servicios acreditados en los mismos, con la finalidad de establecer
      Proyectos de Certificación.
    </p>
    <p>
      A continuación se presentan los Cursos de Capacitación basados en
      Estándares de Competencias que han sido desarrollados en su totalidad por
      Centros de Capacitación o Capacitadores independientes, con la
      autorización de los Comités de Gestión de Competencias correspondientes y
      el CONOCER.
    </p>
  </div>

  <div class="panel">
    <div class="row">
      <div class="container">
        <div class="col-sm-1"></div>
        <div class="col-sm-10 leyenda1">
          <p>
            Registro Nacional de Cursos de Capacitación basados en Estándares de
            Competencia
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="container">
        <div class="col-sm-1">
          <br />
          &nbsp;
          <span
            ><img src="./assets/images/icon/lupa.png" class="iconLupa"
          /></span>
        </div>
        <div class="col-sm-9">
          <mat-form-field appearance="standard">
            <mat-label> Buscar</mat-label>
            <input
              matInput
              (keyup)="applyFilter($event)"
              placeholder="Buscar"
              #input
              oninput="this.value = this.value.toUpperCase()"
            />
          </mat-form-field>
        </div>
        <div class="col-sm-2">
          <mat-form-field appearance="standard">
            <mat-label>Código</mat-label>
            <input
              matInput
              (keyup)="applyFilterCode($event)"
              placeholder="Código"
              #input
              oninput="this.value = this.value.toUpperCase()"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="container">
        <div class="col-sm-3">
          <button mat-raised-button (click)="getCursos(1, 0, null, true)">
            Exportar a Excel
          </button>
        </div>
      </div>
    </div>
    <br />

    <div class="row">
      <div class="container">
        <div class="col-sm-12 example-container">
          <div class="mat-elevation-z8">
            <table
              mat-table
              [dataSource]="dataSource"
              matTableExporter
              #exporter="matTableExporter"
              class="table table-striped table-bordered"
            >
              <ng-container matColumnDef="nombreCurso">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Nombre del curso
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="sectorByID(element)"
                  class="letraE"
                >
                  {{ element.nombreCurso }}
                </td>
              </ng-container>

              <ng-container matColumnDef="capacitador">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Capacitador
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="sectorByID(element)"
                  class="letraE"
                >
                  {{ element.capacitador }}
                </td>
              </ng-container>

              <ng-container matColumnDef="estandar">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Estándar
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="sectorByID(element)"
                  class="letraE"
                >
                  {{ element.estandar }}
                </td>
              </ng-container>
              <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Estado
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="sectorByID(element)"
                  class="letraE"
                >
                  {{ element.estado }}
                </td>
              </ng-container>

              <ng-container matColumnDef="modalidad">
                <th mat-header-cell *matHeaderCellDef class="letraD marcaAgua">
                  Modalidad
                </th>
                <td
                  mat-cell
                  *matCellDef="let element"
                  (click)="sectorByID(element)"
                  class="letraE"
                >
                  {{ element.modalidad }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>

            <div *ngIf="activeEror" class="no-data">
              <p>No se encontraron registros</p>
            </div>

            <br />
          </div>
        </div>
      </div>
    </div>

    <mat-paginator
      [length]="totalElements"
      [pageSize]="pageSize"
      (page)="onPageChange($event)"
      showFirstLastButtons
    >
    </mat-paginator>
  </div>
  <div class="info">
    <p>¿ERES UN CENTRO DE CAPACITACIÓN O CAPACITADOR INDEPENDIENTE?</p>

    <p>
      ¡INTÉGRATE A LA OFERTA DE CURSOS DE CAPACITACIÓN DEL REGISTRO NACIONAL DE
      CURSOS DE CAPACITACIÓN BASADOS EN ESTÁNDARES DE COMPETENCIA!
    </p>
  </div>

  <div class="links">
    <p>
      <a
        href="https://conocer.gob.mx/contenido/transparencia/Articulo/renac.html"
      >
        ¡Conoce los requisitos para la inscripción de tu Oferta de Capacitación
        al RENAC!
      </a>
    </p>
    <img src="./assets/images/Elementos/renac.jpeg" alt="" />
    <p>
      <a
        href="https://conocer.gob.mx/wp-content/uploads/2017/04/RecomendacionesparaaprobarcursosdecapacitacionWEBVEDAPDF.pdf"
      >
        ¡Recomendaciones para aprobar cursos de capacitación alineados a
        Estándares de Competencia!
      </a>
    </p>
  </div>

  <div class="lead">
    <p>
      De acuerdo con las Reglas Generales y criterios para la integración y
      operación del Sistema Nacional de Competencias, vigentes a partir del 27
      de noviembre de 2009, se ha integrado el Registro Nacional de Cursos de
      Capacitación Basados en Estándares de Competencia (RENAC), con los
      Programas de Capacitación que han cumplido con lo dispuesto en su Título
      Cuarto, Capítulo Único, artículos 35, 36, 37 y 38, así como en el Manual
      para la elaboración y actualización del Registro Nacional de Cursos de
      Capacitación basados en Estándares de Competencia.
    </p>

    <p>
      IMPORTANTE: Las personas que hacen uso de la información aquí publicada lo
      hacen en pleno conocimiento de que los programas de capacitación no son
      condicionante, ni garantía para acceder a la evaluación y/o certificación
      de los Estándares de Competencia inscritos en el Registro Nacional de
      Estándares de Competencia (RENEC). Los contenidos y términos de los
      programas de capacitación son responsabilidad exclusiva de los Centros de
      Capacitación o Capacitadores Independientes responsables de éstos.
    </p>
  </div>
</ng-container>
